export default __webpack_public_path__ + "static/media/telegram.4ae118f1.svg";